import type { HostCapabilities } from "../../capabilities";
import { createSettingsHost } from "./host";
import type { MarlinStoreDb } from "../infra/db";
import * as ops from "./store";

export const createSettingsApi = (
  db: MarlinStoreDb,
  capabilities: Pick<HostCapabilities, "files" | "updater" | "syncIntegration">,
) => ({
  getDatarouterConfig: () => ops.getDatarouterConfig(db),
  getIpJsonContent: () => ops.getIpJsonContent(db),
  getAutoUpdateSettings: () => ops.getAutoUpdateSettings(db),
  saveAutoUpdateSettings: (
    settings: Parameters<typeof ops.saveAutoUpdateSettings>[1],
  ) => ops.saveAutoUpdateSettings(db, settings),
  getFeedSettings: () => ops.getFeedSettings(db),
  saveFeedSettings: (settings: Parameters<typeof ops.saveFeedSettings>[1]) =>
    ops.saveFeedSettings(db, settings),
  getVideoSettings: () => ops.getVideoSettings(db),
  saveVideoSettings: (patch: Parameters<typeof ops.saveVideoSettings>[1]) =>
    ops.saveVideoSettings(db, patch),
  getGamepadSettings: () => ops.getGamepadSettings(db),
  saveGamepadSettings: (patch: Parameters<typeof ops.saveGamepadSettings>[1]) =>
    ops.saveGamepadSettings(db, patch),
  getKeyboardSettings: () => ops.getKeyboardSettings(db),
  saveKeyboardSettings: (
    patch: Parameters<typeof ops.saveKeyboardSettings>[1],
  ) => ops.saveKeyboardSettings(db, patch),
  getNotificationSettings: () => ops.getNotificationSettings(db),
  saveNotificationSettings: (
    patch: Parameters<typeof ops.saveNotificationSettings>[1],
  ) => ops.saveNotificationSettings(db, patch),
  consumeReleaseNotesPrompt: (
    currentVersion: Parameters<typeof ops.consumeReleaseNotesPrompt>[1],
  ) => ops.consumeReleaseNotesPrompt(db, currentVersion),
  ...createSettingsHost(db, capabilities),
});

export type SettingsApi = ReturnType<typeof createSettingsApi>;
